var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlurry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    viewBox: "0 0 800 800",
    opacity: 0.24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "bbblurry-filter",
    x: "-100%",
    y: "-100%",
    width: "400%",
    height: "400%",
    filterUnits: "objectBoundingBox",
    primitiveUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 59,
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    in: "SourceGraphic",
    edgeMode: "none",
    result: "blur"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bbblurry-filter)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 641.7675388196376,
    cy: 111.04138307421621,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 422.78284538229093,
    cy: 223.91985173250367,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 703.6964200803748,
    cy: 70.12181215136462,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 758.5494441087333,
    cy: 22.338996208150974,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 587.2593754473783,
    cy: 143.7742525270472,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 490.4610079620521,
    cy: 186.35726529266196,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 284.6714463957941,
    cy: 300.24514243240753,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 153.2622923526465,
    cy: 373.3720412329229,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 96.77999142951364,
    cy: 405.4540012219814,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 353.72647941549405,
    cy: 261.0203258254765,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 215.26969166700752,
    cy: 336.3863998333197,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 46.62549051814051,
    cy: 424.1178901232974,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 352.66555099087856,
    cy: 529.8361106992393,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 285.65629713447925,
    cy: 509.9091028343321,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 804.1813469532274,
    cy: 625.130610760594,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 424.1784632817612,
    cy: 551.2959380624183,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 560.1729236223312,
    cy: 585.6315185786541,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 172.36334803716056,
    cy: 467.0500101618741,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 232.82165303654688,
    cy: 490.62509794385016,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 118.57716337673332,
    cy: 442.56452230882894,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 488.1903787183512,
    cy: 570.7847604801518,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 532.7624722625571,
    cy: 173.46951996968053,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 627.6231334746196,
    cy: 595.0467321585611,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: -14.063511713637013,
    cy: 427.3467070095202,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 685.8570623747341,
    cy: 607.4904352158153,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 751.0796364988958,
    cy: 615.2103613409072,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 240.32514018912593,
    cy: 326.2310725506688,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 461.15564316355136,
    cy: 208.6609513048101,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 326.7398328531475,
    cy: 284.3151912988792,
    fill: "#8c64ccff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 41,
    ry: 41.5,
    cx: 396.3068598402734,
    cy: 244.7579901730203,
    fill: "#8c64ccff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlurry);
export default __webpack_public_path__ + "static/media/blurry.8cdad2779829a4bf6544ae6312eed794.svg";
export { ForwardRef as ReactComponent };